var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgJoke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "url(#Joke_svg__a)",
  rx: 22
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__b)",
  d: "M13.318 25.847a2.96 2.96 0 1 0 0-5.918 2.96 2.96 0 0 0 0 5.918Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__c)",
  d: "M12.775 25.65a2.17 2.17 0 1 0 0-4.34 2.17 2.17 0 0 0 0 4.34Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__d)",
  d: "M30.682 25.847a2.96 2.96 0 1 0 0-5.918 2.96 2.96 0 0 0 0 5.918Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__e)",
  d: "M31.229 25.65a2.17 2.17 0 1 0 0-4.34 2.17 2.17 0 0 0 0 4.34Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__f)",
  d: "M27.723 22.888a2.959 2.959 0 1 0 5.918 0l-2.96-2.959a2.96 2.96 0 0 0-2.958 2.96Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__g)",
  d: "M22.15 35.244h-.3c-5.073 0-9.037-4.382-8.529-9.43l.665-6.609a7.824 7.824 0 0 1 7.784-7.04h.46a7.824 7.824 0 0 1 7.785 7.04l.664 6.609c.508 5.048-3.455 9.43-8.529 9.43Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__h)",
  d: "M24.866 27.41a5.548 5.548 0 0 1-5.695.025l-.04-.024a1.74 1.74 0 0 0-1.386-.192c-1.045.302-2.817 1.036-3.924 2.706a2.313 2.313 0 0 0-.2 2.163c.883 2.133 3.396 6.834 8.377 6.834 4.982 0 7.495-4.701 8.378-6.834a2.313 2.313 0 0 0-.2-2.163c-1.107-1.67-2.88-2.404-3.925-2.706a1.74 1.74 0 0 0-1.385.191Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__i)",
  d: "M28.525 28.274a8.036 8.036 0 0 0-2.273-1.055 1.74 1.74 0 0 0-1.426.216 5.548 5.548 0 0 1-5.695-.024 1.74 1.74 0 0 0-1.385-.192 8.032 8.032 0 0 0-2.273 1.055c1.254 1.893 3.006 2.733 3.854 3.046.145.054.295.095.45.11a1.87 1.87 0 0 0 1.208-.287 1.873 1.873 0 0 1 2.028 0c.362.234.789.332 1.208.288.154-.016.305-.057.45-.11.847-.314 2.6-1.154 3.854-3.047Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__j)",
  d: "M25.006 31.45v-.01h-.001c-.01-.1-.107-.193-.23-.149l-.114.041a1.873 1.873 0 0 1-1.646-.188 1.872 1.872 0 0 0-2.028 0 1.873 1.873 0 0 1-1.646.188l-.115-.04c-.149-.055-.26.093-.222.213.052.434.465 2.902 2.997 2.902h.001c2.543 0 2.948-2.492 2.998-2.908a.163.163 0 0 0 .006-.05Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__k)",
  d: "M22.002 32.005c-.967 0-1.85.361-2.521.955.408.729 1.157 1.446 2.521 1.446h.002c1.364 0 2.112-.716 2.521-1.445a3.797 3.797 0 0 0-2.523-.956Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__l)",
  d: "m24.65 26.353-.678-5.043h-3.945l-.678 5.043a1.475 1.475 0 0 0 1.016 1.61 5.564 5.564 0 0 0 3.27 0 1.475 1.475 0 0 0 1.015-1.61Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__m)",
  d: "M19.337 24.425a.368.368 0 0 1-.368-.368c0-.785-.666-1.423-1.484-1.423-.817 0-1.483.638-1.483 1.423a.368.368 0 0 1-.736 0c0-1.191.996-2.16 2.22-2.16 1.224 0 2.22.969 2.22 2.16a.368.368 0 0 1-.369.368Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__n)",
  d: "M28.368 24.425a.368.368 0 0 1-.368-.368c0-.785-.666-1.423-1.483-1.423-.818 0-1.483.638-1.483 1.423a.368.368 0 0 1-.737 0c0-1.191.996-2.16 2.22-2.16 1.224 0 2.22.969 2.22 2.16a.368.368 0 0 1-.369.368Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__o)",
  d: "M32.727 14.95c-.692.667-1.5.912-1.5.912v1.89c0 .477-.075.952-.22 1.407l-.759 2.384c0-2.997-1.482-3.204-1.482-3.204-1.76-.741-1.396-3.205-1.396-3.205-2.792 4.006-9.348 1.943-9.348 1.943 0-1.397 1.397-1.943 1.397-1.943-3.13 0-3.143 1.85-3.143 1.882 0 1.207-.465 2.369-1.3 3.242l-1.227 1.285-.636-1.879a4.533 4.533 0 0 1-.047-2.829 3.46 3.46 0 0 1 .194-.487c-.957.223-2.22-.174-2.83-.402a.486.486 0 0 1-.31-.535c.204-1.27 1.232-5.194 6.156-5.194-.718-.485-1.155-1.131-1.385-1.557a.462.462 0 0 1 .216-.641c2.37-1.06 13.913-5.7 14.57 4.146 1.142-.804 2.822.492 3.219 2.216a.603.603 0 0 1-.169.569Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__p)",
  d: "m27.371 15.134.91-2.17-.095.063a27.511 27.511 0 0 1-9.471 3.907l-.692.143s6.556 2.063 9.348-1.943Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__q)",
  d: "m16.276 13.772-1.044-.118a5.417 5.417 0 0 0-4.283 1.4l-.758.7a.483.483 0 0 0 .239.192c.609.229 1.872.625 2.83.403a5.232 5.232 0 0 1 2.215-2.167l.8-.41Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__r)",
  d: "M32.73 14.95a.602.602 0 0 0 .172-.548c-1.154-.471-2.433-.527-2.433-.527.842.933.76 1.988.76 1.988s.809-.245 1.501-.913Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__s)",
  d: "M17.486 17.608c-.78 0-1.502.247-2.093.667a.83.83 0 0 0-.107 1.263l.051.052c.29.289.74.315 1.076.082a1.88 1.88 0 0 1 1.073-.334c.4 0 .77.123 1.074.334a.84.84 0 0 0 1.076-.082l.051-.052a.83.83 0 0 0-.107-1.263 3.602 3.602 0 0 0-2.094-.667Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__t)",
  d: "M26.518 17.608c-.78 0-1.503.247-2.094.667a.83.83 0 0 0-.107 1.263l.051.052a.84.84 0 0 0 1.076.082 1.88 1.88 0 0 1 1.074-.334c.398 0 .768.123 1.073.334a.84.84 0 0 0 1.076-.082l.051-.052a.83.83 0 0 0-.107-1.263 3.602 3.602 0 0 0-2.093-.667Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__u)",
  d: "M17.659 33.228c.554.633 1.632.787 2.463-.193a3.534 3.534 0 0 1 2.747-1.25c.367.004.57-.43.335-.711l-7.441-7.459a3.564 3.564 0 0 0-.276-.262c-1.402-1.195-3.467-1.088-4.795.189a2.89 2.89 0 0 0-.204.217 2.96 2.96 0 0 0 2.828 2.089 8.541 8.541 0 0 0 .35 3.389l3.993 3.991Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__v)",
  d: "M12.83 25.74a3.534 3.534 0 0 1 2.746-1.25c.367.005.57-.43.335-.711a3.562 3.562 0 0 0-.422-.426c-1.402-1.195-3.467-1.088-4.795.189-1.909 1.836.558 4.058 2.135 2.198Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__w)",
  d: "m33.513 23.749-.207-.207c-1.328-1.277-3.393-1.384-4.795-.19a3.569 3.569 0 0 0-.422.427.436.436 0 0 0 .082.631l2.547 2.547c.011-.365 0-.736-.036-1.11a2.96 2.96 0 0 0 2.83-2.098Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Joke_svg__x)",
  d: "M31.17 25.74a3.534 3.534 0 0 0-2.746-1.25.434.434 0 0 1-.335-.711c.126-.151.267-.294.422-.426 1.402-1.195 3.468-1.088 4.795.189 1.91 1.836-.558 4.058-2.135 2.198Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__a",
  x1: 4.5,
  x2: 35.5,
  y1: 4.5,
  y2: 44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0991A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEDC5B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__b",
  x1: 11.934,
  x2: 16.586,
  y1: 21.319,
  y2: 26.592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBA5C2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__c",
  x1: 12.143,
  x2: 16.149,
  y1: 24.122,
  y2: 20.055,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4966"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__d",
  x1: 32.066,
  x2: 27.414,
  y1: 21.319,
  y2: 26.592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBA5C2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__e",
  x1: 31.861,
  x2: 27.855,
  y1: 24.122,
  y2: 20.055,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4966"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__f",
  x1: 34.015,
  x2: 24.273,
  y1: 25.422,
  y2: 18.897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4966"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__g",
  x1: 16.905,
  x2: 33.931,
  y1: 18.073,
  y2: 37.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBA5C2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__h",
  x1: 21.513,
  x2: 26.47,
  y1: 30.607,
  y2: 38.471,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__i",
  x1: 21.999,
  x2: 21.999,
  y1: 29.52,
  y2: 34.39,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#343168",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B1464"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__j",
  x1: 22.001,
  x2: 22.001,
  y1: 27.991,
  y2: 33.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF0084"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#393168"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__k",
  x1: 22.003,
  x2: 22.003,
  y1: 32.374,
  y2: 34.119,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF91CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD2BB6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__l",
  x1: 22,
  x2: 22,
  y1: 23.268,
  y2: 33.626,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D30036"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__m",
  x1: 16.275,
  x2: 18.581,
  y1: 22.231,
  y2: 25.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__n",
  x1: 25.306,
  x2: 27.612,
  y1: 22.231,
  y2: 25.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__o",
  x1: 18.705,
  x2: 22.954,
  y1: 10.003,
  y2: 17.348,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__p",
  x1: 23.486,
  x2: 22.166,
  y1: 11.957,
  y2: 24.066,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#343168",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B1464"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__q",
  x1: 13.406,
  x2: 12.66,
  y1: 13.181,
  y2: 20.02,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#343168",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B1464"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__r",
  x1: 31.777,
  x2: 30.775,
  y1: 14.091,
  y2: 16.139,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#343168",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1B1464"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__s",
  x1: 17.486,
  x2: 17.486,
  y1: 17.835,
  y2: 20.586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__t",
  x1: 26.518,
  x2: 26.518,
  y1: 17.835,
  y2: 20.586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__u",
  x1: 16.857,
  x2: 15.347,
  y1: 27.372,
  y2: 21.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4966"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__v",
  x1: 11.064,
  x2: 14.503,
  y1: 23.09,
  y2: 26.006,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3FA9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#868BFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__w",
  x1: 32.77,
  x2: 28.065,
  y1: 26.012,
  y2: 21.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCCECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4966"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Joke_svg__x",
  x1: 32.943,
  x2: 29.504,
  y1: 23.091,
  y2: 26.007,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3FA9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#666AD6"
})))));
export { SvgJoke as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMzVlMDUwYmJkOGUzZjg1NzJiZjQ2YjJiNDg3MTZmMzMuc3ZnIjs=";